var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 8.26795C18.3333 9.03775 18.3333 10.9623 17 11.7321L3.5 19.5263C2.16667 20.2961 0.500001 19.3338 0.500001 17.7942L0.500002 2.20577C0.500002 0.66617 2.16667 -0.29608 3.5 0.47372L17 8.26795Z","fill":"#F2F4F8"}));
}

Play.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = Play;

Play.default = Play;
